import { Loading } from "app/components";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { formatDate } from "app/utils/utility.service";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";
import { Fragment, useEffect, useRef, useState, useMemo } from "react";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatNumber } from "app/utils/utility.service";
import {
  addLoans,
  editLoanSchedule,
  editPropertyDetails,
  getLoanDetails,
  saveLoans,
} from "../../../homepurchase.service";
import { current } from "@reduxjs/toolkit";
import { secondLoanInterestRate } from "app/utils/Constants";
import { NumericFormat } from "react-number-format";

const amortizationYears = [
  { name: "15 Years", code: 15 },
  { name: "30 Years", code: 30 },
  { name: "40 Years", code: 40 },
];

const secondAmortizationYears = [{ name: "12 Years", code: 12 }];

const MortgageSchedule = ({
  MortgageModal,
  handleEditMortgagePaymentModal,
  values,
  fetchLoanDetails,
  firstPrincipal,
  secondPrincipalAmt
}) => {
  const onHide = () => {
    handleEditMortgagePaymentModal(false);
  };
  const toast = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [extra, setExtra] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [startDateError, setStartDateError] = useState(false);
  const [firstRef, setFirstRef] = useState(false);
  const [secondRef, setSecondRef] = useState(false);
  const [loanAmountInvalid, setLoanAmountInvalid] = useState(false);
  const [extraPayment, setExtraPayment] = useState(0);
  const [monthlyPayment, setMonthlyPayment] = useState(0);
  const [scheduleReady, setScheduleReady] = useState(false);
  const [currentLoan, setcurrentLoan] = useState(null);
  const initialValues = {
    month: "",
    date: "",
    extraPayment: 0,
    principal: "",
    interest: "",
    balance: "",
    year: "",
  };
  const [scheduleType, setScheduleType] = useState("Monthly"); // Toggle state
  const [showMore, setShowMore] = useState(false);

  const [newMonthlyschedule, setNewMonthlyschedule] = useState([initialValues]);
  const [newAnnualschedule, setNewAnnualschedule] = useState([initialValues]);
  const [lastRecordMonth, setLastRecordMonth] = useState([]);
  const [lastRecordYear, setLastRecordYear] = useState([]);
  const [totalMortgagePayment, setTotalMortgagePayment] = useState(0);
  const [totalInterest, setTotaInterest] = useState(0);
  const [startDateMonthNullError, setStartDateMonthNullError] = useState(false);
  const [startDateYearNullError, setStartDateYearNullError] = useState(false);
  const [secondStartDateMonthNullError, setSecondStartDateMonthNullError] =
    useState(false);
  const [secondStartDateYearNullError, setSecondStartDateYearNullError] =
    useState(false);
  const [amortization, setAmortization] = useState(values?.amortization); // years

  const [instalments, setInstalments] = useState(values?.amortization);
  const [principal, setPrincipal] = useState(values?.mortgage); // Loan amount

  const [rate, setRate] = useState(values?.rateOfInterest);
  const [rateNull, setRateNull] = useState(false);
  const [rateNullFirst, setRateNullFirst] = useState(false);
  const [secondrate, setSecondrate] = useState(values?.secondRateOfInterest);
  const [secondAmortization, setSecondAmortization] = useState(
    values?.secondAmortization
  );
  const [secondStartDateYear, setSecondStartDateYear] = useState();
  const [secondStartDateMonth, setSecondStartDateMonth] = useState();
  const [secondPrincipal, setSecondPrincipal] = useState(
    values?.secondPrincipal
  );

  const currentYear = 1900;

  const years = Array.from({ length: 200 }, (_, i) => ({
    label: `${currentYear + i}`,
    value: currentYear + i,
  }));
  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  const setPrincipalValue = (name, values) => {
    let val = values.target.value.replace(/[$,]/g, '');
    // handleInputChange(e);
    if (name === "mortgage") {
      setPrincipal( parseFloat(val));
    } else {
      setSecondPrincipal( parseFloat(val?val:0));
    }
  };
  const setRateValue = (name, values)  => {
    let val = values.target.value.replace(/[$,]/g, '');
    // handleInputChange(e);
    if (name === "rateOfInterest") {
      setRate(parseFloat(val));
    } else {
      setSecondrate(parseFloat(val?val:0));
    }
  };
  const setTermValue = (e) => {
    if (e.target.name === "amortization") {
      setAmortization(e.value);
    } else {
      setSecondAmortization(e.value);
    }
  };
  const setStartYearValue = (e) => {
    setSelectedYear(e.value);
  };
  const setStartYearValueSecond = (e) => {
    setSecondStartDateYear(e.value);
  };
  const setStartMonthValue = (e) => {
    setSelectedMonth(e.value);
  };
  const setStartMonthValueSecond = (e) => {
    setSecondStartDateMonth(e.value);
  };
  const months = [
    { label: "January", value: "1" },
    { label: "February", value: "2" },
    { label: "March", value: "3" },
    { label: "April", value: "4" },
    { label: "May", value: "5" },
    { label: "June", value: "6" },
    { label: "July", value: "7" },
    { label: "August", value: "8" },
    { label: "September", value: "9" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ];
  const setPayment = (e) => {
    if (checked && extra) setExtraPayment(e);
    let updatedScheduleMonthly = [];
    let updatedScheduleAnnual = [];
    if (scheduleType === "Monthly") {
      updatedScheduleMonthly = newMonthlyschedule.map((entry) => ({
        ...entry,
        extraPayment: (Number(e) || 0).toFixed(2),
      }));
      setNewMonthlyschedule(updatedScheduleMonthly);
      // Keep annual view in sync
      setNewAnnualschedule(aggregateMonthlyToAnnual(updatedScheduleMonthly));
    } else {
      updatedScheduleAnnual = newAnnualschedule.map((entry) => ({
        ...entry,
        extraPayment: (Number(e) || 0).toFixed(2),
      }));
      setNewAnnualschedule(updatedScheduleAnnual);
      // Propagate annual changes down to monthly (even distribution)
      setNewMonthlyschedule(distributeAnnualsToMonthly(updatedScheduleAnnual, newMonthlyschedule));
    }
    if (lastRecordMonth && lastRecordMonth[0]) {
      setLastRecordMonth([{ ...lastRecordMonth[0], extraPayment: (Number(e) || 0).toFixed(2) }]);
    }
  };

  useEffect(() => {
    const getLoan = async () => {
      const loan = await getLoanDetails(values.userId, values.id);
      setcurrentLoan(loan);
      //If loan schedule doesnt exist in db, then caculate and save it
      if (!loan) calculateAnnualSchedule(scheduleType);
      else {
        const annualSchedules = loan.loanSchedules.filter(
          (schedule) => schedule.scheduleType === "Annual"
        );
        const monthlySchedules = loan.loanSchedules.filter(
          (schedule) => schedule.scheduleType === "Monthly"
        );

        setNewMonthlyschedule(monthlySchedules);
        setNewAnnualschedule(annualSchedules);
        setLastRecordMonth([monthlySchedules[monthlySchedules.length - 1]]);

        const date = new Date(loan.firstLoanStartDate);
        setSelectedYear(date.getFullYear());
        setSelectedMonth(date.getMonth() + 1);

        const date1 = new Date(loan.secondLoanStartDate);
        setSecondStartDateYear(date1.getFullYear());
        setSecondStartDateMonth(date1.getMonth() + 1);
        setMonthlyPayment(formatNumber(loan.monthlyPay));
        setTotalMortgagePayment(loan.totalMortgagePayments);
        setTotaInterest(loan.totalInterest);

        // Check if all extraPayment values are 0
        let allZero = monthlySchedules.every(
          (item) => item.extraPayment === "0.00"
        );
        setChecked(!allZero);

        let isUniform = false;

        if (!allZero) {
          // Check if extraPayment values are non-uniform
          //isUniform = new Set(loan.loanSchedules.map(item => item.extraPayment)).size === 1;
          const extraPayments = monthlySchedules.map(
            (item) => item.extraPayment
          );
          const isUniform = extraPayments.every(
            val => val === extraPayments[0]
          );
          setExtra(isUniform);
          if (isUniform) {
            setExtraPayment(extraPayments[0]);
          }
        }
      }
    };
    setSelectedYear(new Date(values?.createdAt).getFullYear());
    setSelectedMonth(new Date(values?.createdAt).getMonth() + 1);
    setSecondStartDateYear(new Date(values?.createdAt).getFullYear());
    setSecondStartDateMonth(new Date(values?.createdAt).getMonth() + 1);
    getLoan();
  }, [MortgageModal]);

  const saveLoanDetails = async (schedule) => {
    let req = {};
    req.userId = values.userId;
    req.property_id = values.id;
    req.loan_type = "Starting";
    req.firstLoanStartDate = buildIsoDate(selectedYear, selectedMonth);
    req.secondLoanStartDate = buildIsoDate(secondStartDateYear, secondStartDateMonth);
    req.monthlyPay = schedule.monthlyPayment;
    req.totalMortgagePayments = schedule.totalMortgagePayment;
    req.totalInterest = schedule.totalInterest;
    // Convert loanSchedules object to an array
    const formattedSchedule = Object.values(schedule.schedule);
    req.loanSchedules = formattedSchedule;

    await saveLoans(req);
    setTimeout(() => {
          fetchLoanDetails();
        }, 1000);
  };
 
  // Helper to build ISO date string for a given year and month (1-based month)
  const buildIsoDate = (year, month) => {
    if (!year || !month) return null;
    const mm = String(Number(month)).padStart(2, "0");
    return `${year}-${mm}-01`;
  };




  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const saveAnnualSchedule = async () => {
    let schedule = calculateAnnualSchedule(scheduleType);

    if (schedule) {
      let req = values;
      req.mortgage = principal;
      req.rateOfInterest = rate;
      req.amortization = amortization;
      req.secondRateOfInterest = secondrate;
      req.secondPrincipal = secondPrincipal;
      req.secondAmortization = secondAmortization;
      if(firstPrincipal !== values.mortgage || secondPrincipalAmt !== secondPrincipalAmt) {
        req.valuesModified = true;
      }

      const details = await editPropertyDetails(req, values.id);

      const loan = await getLoanDetails(values.userId, values.id);

      if (!loan) saveLoanDetails(schedule);
      else {
        let req = {};
        req.userId = values.userId;
        req.id = currentLoan.id;
        req.property_id = values.id;
        req.loan_type = "Starting";
        req.firstLoanStartDate = buildIsoDate(selectedYear, selectedMonth);
        req.secondLoanStartDate = buildIsoDate(secondStartDateYear, secondStartDateMonth);
        req.monthlyPay = schedule.monthlyPayment;
        req.totalMortgagePayments = schedule.totalMortgagePayment;
        req.totalInterest = schedule.totalInterest;
        // Convert loanSchedules object to an array
        let formattedSchedule = null;
        if (scheduleType === "Monthly")
          formattedSchedule = Object.values(schedule.schedule);
        else formattedSchedule = Object.values(schedule.schedule);

        req.loanSchedules = formattedSchedule;
        const response = editLoanSchedule(req, currentLoan.id);
        setTimeout(() => {
          fetchLoanDetails();
        }, 1000);
      }

      showSuccess("Mortgage payment details updated successfully");
    }
  };

  const calculateAnnualSchedule = (schedule) => {

    if (rate <= 0) {
      setRateNullFirst(true);
      return;
    } else setRateNullFirst(false);
    if (secondPrincipal > 0 && secondrate <= 0) {
      setRateNull(true);
      return;
    } else {
      setRateNull(false);
    }
    if (
      parseFloat(principal) + parseFloat(secondPrincipal) >
      values?.purchasePrice - values?.downPayment
    ) {
      setLoanAmountInvalid(true);
      return;
    } else setLoanAmountInvalid(false);

    if (checked && extra) setPayment(extraPayment);
    let loanAmount = principal;
    let interestRate = rate;
    let term1 = amortization;

    let secondMortgage = secondPrincipal;
    let secondInterestRate = secondrate;
    let term2 = secondAmortization;

    const monthlyRate = interestRate / 100 / 12;
    const monthlyRate2 = secondInterestRate / 100 / 12;
    const months = term1 * 12;
    // If second mortgage is not present, treat its months as 0 to avoid NaN and unexpected behavior
    const months2 = secondMortgage > 0 && term2 ? term2 * 12 : 0;

    // First mortgage monthly payment
    const monthlyPayment1 =
      (loanAmount * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -months));

    // Second mortgage monthly payment
    let monthlyPayment2 = 0;
    if (secondMortgage > 0)
      monthlyPayment2 =
        (secondMortgage * monthlyRate2) /
        (1 - Math.pow(1 + monthlyRate2, -months2));

    setMonthlyPayment(
      new Intl.NumberFormat("en-US").format(
        Math.round(monthlyPayment1 + monthlyPayment2)
      )
    );
    let balance1 = loanAmount;
    let balance2 = secondMortgage? secondMortgage:0;

    const newSchedule = [];
    const newScheduleMonthly = [];
    let yearInterest = 0;
    let yearPrincipal = 0;
    let startDate = new Date(values?.createdAt);
    let sumInterest = 0;
    let totalI = 0;
    let totalP = 0;
    let i = 0;
    let yearCount = 0;
    let monthCount = 0;

    let totalInterest = 0;
    let totalPrincipal = 0;
    let totalBalance = 0;
    let loanCategory = "First Loan";
    let tot = 0;

    // Determine first/second start dates (use selected values or fallback to createdAt)
    const firstStartYear = selectedYear || new Date(values?.createdAt).getFullYear();
    const firstStartMonth = selectedMonth || new Date(values?.createdAt).getMonth() + 1;
    const secondStartYear = secondStartDateYear || new Date(values?.createdAt).getFullYear();
    const secondStartMonth = secondStartDateMonth || new Date(values?.createdAt).getMonth() + 1;

    const firstStartDate = new Date(firstStartYear, Number(firstStartMonth) - 1, 1);
    const secondStartDate = new Date(secondStartYear, Number(secondStartMonth) - 1, 1);

    // If a loan has zero principal, ignore its start date when computing the overall start date.
    const validStartDates = [];
    if (loanAmount > 0) validStartDates.push(firstStartDate);
    if (secondMortgage > 0) validStartDates.push(secondStartDate);
    // Fall back to createdAt if both loans are absent (edge case)
    const fallbackStart = new Date(values?.createdAt);
    const overallStartDate = validStartDates.length
      ? new Date(Math.min(...validStartDates.map((d) => d.getTime())))
      : fallbackStart;
    let year = overallStartDate.getFullYear();
    let month = overallStartDate.getMonth() + 1;

    // Add a safety upper bound to avoid accidental infinite loops
    const maxIterations = Math.max(months, months2) + 1200;
    let iterCount = 0;

    while (i < Math.max(months, months2) || balance1 > 0 || balance2 > 0) {
      if (++iterCount > maxIterations) {
        console.warn("MortgageSchedule: reached max iterations, aborting schedule generation");
        break;
      }
      let extraPayment = 0;
      const monthDate = new Date(year, Number(month) + i - 1, 1);
      if (schedule === "Monthly")
        extraPayment = Number(getExtraPayment(i + 1, schedule));
      else {
        //Add extra payment only after 12 months
        if (i % 12 === 0)
          extraPayment = Number(getExtraPayment(Math.ceil((i + 1) / 12), schedule));
        else extraPayment = 0;
      }

      // Compute per-loan interest/principal only when that loan has started
      let interest1 = 0;
      let principal1 = 0;
      let interest2 = 0;
      let principal2 = 0;

      const includeFirst = monthDate >= firstStartDate && loanAmount > 0;
      const includeSecond = monthDate >= secondStartDate && secondMortgage > 0;

      if (includeFirst) {
        interest1 = balance1 * monthlyRate;
        principal1 = Math.min(monthlyPayment1 - interest1 + extraPayment, balance1);
        balance1 -= principal1;
      }

      if (includeSecond) {
        interest2 = balance2 * monthlyRate2;
        principal2 = Math.min(monthlyPayment2 - interest2, balance2);
        balance2 -= principal2;
      }

      // Aggregate totals
      totalInterest = interest1 + interest2;
      totalPrincipal = principal1 + principal2;
      totalBalance = (includeFirst ? balance1 : 0) + (includeSecond ? balance2 : 0);

      // Determine loanCategory
      if (includeFirst && includeSecond) loanCategory = "First + Second Loan";
      else if (includeFirst) loanCategory = "First Loan";
      else if (includeSecond) loanCategory = "Second Loan";
      else loanCategory = "";

      // Store monthly or annual data
      if (totalBalance > 0) {
        monthCount++;
        newScheduleMonthly.push({
          month: monthCount,
           date: monthDate.toLocaleDateString("en-US", {

            year: "numeric",
            month: "short",
          }),
          displayDate: monthDate.toLocaleString("en-US", { year: "numeric", month: "short" }),
          extraPayment: (Number(extraPayment) || 0).toFixed(2),
          interest: (totalInterest).toFixed(2),
          principal: (totalPrincipal).toFixed(2),
          balance: (totalBalance).toFixed(2),
          loanCategory: loanCategory,
          scheduleType: schedule,
        });
      }

      totalI += totalInterest;
      totalP += totalPrincipal;

      // Aggregate interest and principal for annual schedule
      yearInterest += totalInterest;
      yearPrincipal += totalPrincipal;
      i++;

      if ((i % 12 === 0 || i === months) && totalBalance > 0) {
        // Add annual data every 12 months or at the end of the term
        // if (schedule === "Annual") {
        yearCount++;
        newSchedule.push({
          year: yearCount,
           date: monthDate.toLocaleDateString("en-US", {

            year: "numeric",
          }),
          displayDate: String(monthDate.getFullYear()),
          interest: (yearInterest).toFixed(2),
          principal: (yearPrincipal).toFixed(2),
          balance: (totalBalance).toFixed(2),
          extraPayment: (Number(getExtraPayment(Math.ceil(i / 12), schedule)) || 0).toFixed(2),
          loanCategory: loanCategory,
          scheduleType: schedule,
        });

        //  }
        sumInterest += yearInterest;

        // Reset annual aggregation
        yearInterest = 0;
        yearPrincipal = 0;
      }

      if ((balance1 <= 0 || i >= months) && (balance2 <= 0 || i >= months2)) {
        if (yearInterest > 0 || yearPrincipal > 0) {
          yearCount++;
          newSchedule.push({
            year: yearCount,
             date: monthDate.toLocaleDateString("en-US", {

              year: "numeric",
            }),
            displayDate: String(monthDate.getFullYear()),
            interest: (yearInterest).toFixed(2),
            principal: (yearPrincipal).toFixed(2),
            balance: (totalBalance).toFixed(2),
            extraPayment: (Number(getExtraPayment(Math.ceil(i / 12), schedule)) || 0).toFixed(2),
            loanCategory: loanCategory,
            scheduleType: schedule,
          });
        }
        sumInterest += yearInterest;
        setTotaInterest(sumInterest);
        tot = totalP + totalI - extraPayment * (i - 1);
        setTotalMortgagePayment(tot);
        setInstalments(i);
        break; // Stop early if balances are paid off
      }
    }

   // if (schedule === "Monthly") {
      setNewMonthlyschedule([...newScheduleMonthly]);
      setLastRecordMonth([newScheduleMonthly[newScheduleMonthly.length - 1]]);
   // }

   // if (schedule === "Annual") {
      setNewAnnualschedule([...newSchedule]);
      setLastRecordYear([newSchedule[newSchedule.length - 1]]);
   // }
    if (schedule === "Monthly")
      return {
        schedule: newScheduleMonthly,
        monthlyPayment: Math.round(monthlyPayment1 + monthlyPayment2),
        totalMortgagePayment: tot,
        totalInterest: sumInterest,
      };
    else
      return {
        schedule: newSchedule,
        monthlyPayment: Math.round(monthlyPayment1 + monthlyPayment2),
        totalMortgagePayment: tot,
        totalInterest: sumInterest,
      };
    // setScheduleReady(true); // Mark schedule as ready for saving
  };
  // Update schedule when extra payment is changed
  const handleExtraPaymentChange = (e, rowIndex, rowData) => {
    const newValue = Number(e.value).toFixed(2);
    if (newValue !== rowData.extraPayment) {
      const updatedSchedule = [...newMonthlyschedule];
      updatedSchedule[rowIndex].extraPayment = newValue;
      setNewMonthlyschedule(updatedSchedule);
      // Keep annual in sync (incremental approach could be added later)
      setNewAnnualschedule(aggregateMonthlyToAnnual(updatedSchedule));
    }
  }; 
  const handleExtraPaymentChangeAnnual = (e, rowIndex, rowData) => {
    const newValue = Number(e.value).toFixed(2);
    if (newValue !== rowData.extraPayment) {
      const updatedSchedule = [...newAnnualschedule];
      updatedSchedule[rowIndex].extraPayment = newValue;
      setNewAnnualschedule(updatedSchedule);
      // Propagate annual changes to monthly schedule
      setNewMonthlyschedule(distributeAnnualsToMonthly(updatedSchedule, newMonthlyschedule));
    }
  }; 
  const mainDataMonth = showMore
    ? newMonthlyschedule.slice(0, newMonthlyschedule.length)
    : newMonthlyschedule.slice(0, 3);
  const mainDataAnnual = showMore
    ? newAnnualschedule.slice(0, newAnnualschedule.length)
    : newAnnualschedule.slice(0, 3);

  // Helper function to get the extra payment for each month from the schedule
  const getExtraPayment = (monthIndex, schedule) => {
    let extraPaymentRow;

    if (schedule === "Monthly") {
      extraPaymentRow = newMonthlyschedule[monthIndex - 1]; // monthIndex is 1-based
    } else {
      extraPaymentRow = newAnnualschedule[monthIndex - 1];
    }

    return extraPaymentRow ? extraPaymentRow.extraPayment : 0;
  };

  // Aggregate monthly -> annual (keeps annual schedule in sync)
  const aggregateMonthlyToAnnual = (monthly) => {
    const map = {};
    monthly.forEach((m) => {
      const dateStr = m.date || m.displayDate;
      const y = new Date(dateStr).getFullYear();
      if (!map[y]) {
        map[y] = {
          year: Number(y),
          displayDate: String(y),
          interest: 0,
          principal: 0,
          balance: 0,
          extraPayment: 0,
          loanCategory: m.loanCategory || "",
          scheduleType: "Annual",
        };
      }
      map[y].interest += Number(m.interest || 0);
      map[y].principal += Number(m.principal || 0);
      map[y].extraPayment += Number(m.extraPayment || 0);
      map[y].balance = Number(m.balance || 0); // last month in year determines balance
    });
    return Object.values(map)
      .sort((a, b) => a.year - b.year)
      .map((a) => ({
        ...a,
        interest: (a.interest).toFixed(2),
        principal: (a.principal).toFixed(2),
        balance: (a.balance).toFixed(2),
        extraPayment: (a.extraPayment).toFixed(2),
      }));
  };

  // Distribute annual rows' extraPayment across the months that actually exist in that year
  const distributeAnnualsToMonthly = (annuals, monthly) => {
    if (!Array.isArray(annuals) || !Array.isArray(monthly)) return monthly;
    const monthlyByYear = monthly.reduce((acc, m, idx) => {
      const y = new Date(m.date || m.displayDate).getFullYear();
      if (!acc[y]) acc[y] = [];
      acc[y].push({ idx, m });
      return acc;
    }, {});

    const result = [...monthly];

    annuals.forEach((a) => {
      const y = Number(a.year) || new Date(a.date).getFullYear();
      const monthsForYear = monthlyByYear[y] || [];
      if (monthsForYear.length === 0) return; // nothing to distribute
      const totalCents = Math.round((Number(a.extraPayment || 0) || 0) * 100);
      const perMonthCents = Math.floor(totalCents / monthsForYear.length);
      let remainder = totalCents - perMonthCents * monthsForYear.length;
      // distribute the perMonthCents and distribute the extra cents to earliest months
      monthsForYear.forEach(({ idx }, i) => {
        const add = perMonthCents + (remainder > 0 ? 1 : 0);
        remainder = Math.max(0, remainder - 1);
        result[idx] = { ...result[idx], extraPayment: ((add / 100).toFixed(2)) };
      });
    });

    return result;
  };

  // Render the editable extra payment field
  const extraPaymentTemplate = (rowData, { rowIndex }) => {
    return (
      <InputNumber
        className="custom-input-number vw-inputnumber-with-border"
        value={rowData.extraPayment}
        onValueChange={(e) => handleExtraPaymentChange(e, rowIndex, rowData)}
      />
    );
  };
  const extraPaymentTemplateAnnual = (rowData, { rowIndex }) => {
    return (
      <InputNumber
        className="custom-input-number vw-inputnumber-with-border"
        value={rowData.extraPayment}
        onValueChange={(e) =>
          handleExtraPaymentChangeAnnual(e, rowIndex, rowData)
        }
      />
    );
  };
  return (
    <Dialog
      header={"Mortgage"}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "70vw" }}
        contentStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      className="AnnualExpenseModal"
      visible={MortgageModal}
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      {isLoading && <Loading />}
      <Toast ref={toast} className="ToastMessage" />

      <div className="grid">
        <div className="grid col-8 custom-background mt-5 custom-margin">
          <div className="col-7  mt-4 ">
            <div className="text-align-center mr-3">
              <span style={{ color: "#6c757d", fontSize: "1.2rem" }}>
                <b>First Mortgage</b>
              </span>
            </div>
            <div className="grid mt-3">
              <div className="col-12 md:col-12 lg:col-4 mt-2">
                <label> Loan Amount</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{"width":"99%"}}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      name="mortgage"
                      prefix="$ "
                      allowNegative={false}
                      decimalScale={0}
                      value={principal}
                      onBlur={(values) => {
                      setPrincipalValue("mortgage", values);
                      }}
                    />
                  </div>
                  {loanAmountInvalid && (
                    <div className="text-align-left errormsg-margin mt-4">
                      <small className="p-error">
                        Please enter loan amount less than purchase price
                      </small>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="grid mt-1">
              <div className="col-12 md:col-12 lg:col-4 mt-2">
                <label>Loan Term </label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="">
                  <div className="p-inputgroup">
                    <Dropdown
                      className="vw-dropdown vw-dropdown-with-border"
                      value={amortization}
                      options={amortizationYears}
                      required={true}
                      name="amortization"
                      onChange={setTermValue}
                      optionLabel="name"
                      optionValue="code"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid mt-1">
              <div className="col-12 md:col-12 lg:col-4 mt-2">
                <label>Interest Rate</label>
              </div>
              <div className="col-12 md:col-12 lg:col-6">
                <div className="">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{"width":"99%"}}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      name="rateOfInterest"
                      value={rate}
                      allowNegative={false}
                      decimalScale={2}
                      onBlur={(values) => {
                      setRateValue("rateOfInterest", values);
                      }}
                      suffix={" %"}
                    />
                  </div>
                  {rateNullFirst && (
                    <div className="text-align-left errormsg-margin mt-2">
                      <small className="p-error">Please enter rate</small>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="grid mt-1">
              <div className="col-12 md:col-12 lg:col-4 mt-2">
                <label>Start Date</label>
              </div>

              <div className="grid lg:col-7 ">
                <div className="col-6" style={{ width: "7.7rem" }}>
                  <Dropdown
                    className=" vw-dropdown  vw-dropdown-with-border"
                    id="year"
                    name="firstyear"
                    value={selectedYear}
                    onChange={setStartYearValue}
                    options={years}
                    placeholder="Year"
                    style={{
                      border: "1px solid #ced4da", // Customize the border color and width
                      borderRadius: "3px", // Optional: round the corners
                      padding: "5px", // Optional: add padding for spacing
                      height: "3.5rem",
                    }}
                  />
                  &nbsp;
                </div>

                <div className="col-6" style={{ width: "9rem" }}>
                  <Dropdown
                    className=" vw-dropdown  vw-dropdown-with-border custom-dropdown"
                    id="month"
                    name="firstmonth"
                    value={selectedMonth + ""}
                    options={months}
                    onChange={setStartMonthValue}
                    placeholder="Month"
                    style={{
                      border: "1px solid #ced4da", // Customize the border color and width
                      borderRadius: "3px", // Optional: round the corners
                      padding: "5px", // Optional: add padding for spacing
                      height: "3.5rem",
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={{ width: "57.5rem" }}>
              {/* <div className="grid" style={{ width: "53rem" }}>
            <div
              className="flex align-items-center text-start ml-3 mt-4"
              style={{ gap: "1rem" }}
            >
              <b>Refinance</b>
              
              <div className="flex align-items-center">
                <Checkbox
                  inputId="makeExtraPayments"
                  className="custom-red-checkbox"
                  onChange={(e) => {
                    setFirstRef(e.checked);
                  }}
                  checked={firstRef}
                />
                <label htmlFor="makeExtraPayments" className="ml-2">
                  First Mortgage
                </label>
              </div>


                <>
                  <div className="flex align-items-center ml-6">
                    <Checkbox
                      inputId="uniformExtraPayments"
                      className="custom-red-checkbox"
                      onChange={(e) => {
                        setSecondRef(e.checked);
                      }}
                      checked={secondRef}
                    />
                    <label htmlFor="uniformExtraPayments" className="ml-2">
                      Second Mortgage
                    </label>
                  </div>


                </>
              
            </div>
          </div> */}
            </div>
          </div>
          <div class="vertical-line"></div>
          <div className="ml-7 col-4 mt-4 ">
            <div>
              <span style={{ color: "#6c757d", fontSize: "1.2rem" }}>
                <b>Second Mortgage</b>
              </span>
            </div>
            <div className=" mt-3">
              <div className="grid mt-2">
                <div className="col-12 md:col-12 lg:col-11">
                  <div className="">
                    <div className="p-inputgroup">
                      <NumericFormat
                        className="input-field"
                        style={{"width":"99%"}}
                        thousandSeparator=","
                        autoComplete="off"
                        required={true}
                        name="secondPrincipal"
                        prefix="$ "
                        value={secondPrincipal}
                        allowNegative={false}
                        decimalScale={0}
                        onBlur={(values) => {
                        setPrincipalValue("secondPrincipal", values);
                        
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid mt-1">
                <div className="col-12 md:col-12 lg:col-11">
                  <div className="">
                    <div className="p-inputgroup">
                      <Dropdown
                        className="vw-dropdown vw-dropdown-with-border"
                        value={secondAmortization}
                        options={secondAmortizationYears}
                        required={true}
                        name="secondAmortization"
                        onChange={setTermValue}
                        optionLabel="name"
                        optionValue="code"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid mt-1">
                <div className="col-12 md:col-12 lg:col-11">
                  <div className="">
                    <div className="p-inputgroup">
                      <NumericFormat
                        className="input-field"
                        style={{"width":"99%"}}
                        thousandSeparator=","
                        autoComplete="off"
                        required={true}
                        name="secondrate"
                        allowNegative={false}
                        decimalScale={2}
                        suffix=" %"
                        value={secondrate}
                        onBlur={(values) => {
                        setRateValue("secondrate", values);
                        }}
                      />
                    </div>
                    {rateNull && (
                      <div className="text-align-left errormsg-margin mt-2">
                        <small className="p-error">Please enter rate</small>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid mt-1">
                <div className="col-12 md:col-12 lg:col-12">
                  <div className="">
                    <div className="grid">
                      <div className="col-6" style={{ width: "8rem" }}>
                        <Dropdown
                          className=" vw-dropdown  vw-dropdown-with-border"
                          id="year"
                          value={secondStartDateYear}
                          onChange={setStartYearValueSecond}
                          options={years}
                          placeholder="Year"
                          style={{
                            border: "1px solid #ced4da", // Customize the border color and width
                            borderRadius: "3px", // Optional: round the corners
                            padding: "5px", // Optional: add padding for spacing
                            height: "3.5rem",
                          }}
                        />
                        &nbsp;
                      </div>
                      <div className="col-6" style={{ width: "9rem" }}>
                        <Dropdown
                          className=" vw-dropdown  vw-dropdown-with-border custom-dropdown"
                          id="month"
                          value={secondStartDateMonth + ""}
                          options={months}
                          onChange={setStartMonthValueSecond}
                          placeholder="Month"
                          style={{
                            border: "1px solid #ced4da", // Customize the border color and width
                            borderRadius: "3px", // Optional: round the corners
                            padding: "5px", // Optional: add padding for spacing
                            height: "3.5rem",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-3 custom-background mt-5 p-4">
          <div className="grid ">
            <div className="col-12 md:col-12 lg:col-6 mt-3 align-text">
              <label>Monthly Pay - </label>
            </div>
            <div className="col-12 md:col-12 lg:col-6 mt-3">
              <div>
                <div>
                  <label>{"$ " + monthlyPayment}</label>
                </div>
              </div>
            </div>
          </div>

          <div className="grid ">
            <div className="col-12 md:col-12 lg:col-6 mt-3 align-text">
              <label>House Price - </label>
            </div>
            <div className="col-12 md:col-12 lg:col-6 mt-3">
              <div>
                <div>
                  {/* <InputNumber
                    className="vw-inputnumber-with-border"
                    autoComplete="off"
                    required={true}
                    name="purchasePrice"
                    prefix="$ "
                    disabled={true}
                    value={values?.purchasePrice}
                  />*/}
                  <label>{"$ " + formatNumber(values?.purchasePrice)}</label>
                </div>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12 lg:col-6 mt-3 align-text">
              <label>Loan Amount - </label>
            </div>
            <div className="col-12 md:col-12 lg:col-6 mt-3">
              <div>
                <div>
                  <label>
                    {"$ " +
                      formatNumber(Number(principal) + Number(secondPrincipal?secondPrincipal:0))}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="grid ">
            <div className="col-12 md:col-12 lg:col-6 mt-3 align-text">
              <label>Down Payment - </label>
            </div>
            <div className="col-12 md:col-12 lg:col-6 mt-3">
              <div>
                <div>
                  <label>{"$ " + formatNumber(values?.downPayment)}</label>
                </div>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12 lg:col-6 mt-3 align-text">
              <label>Total of {instalments} Mortgage Payments - </label>
            </div>
            <div className="col-12 md:col-12 lg:col-6 mt-3">
              <div>
                <div>
                  <label>
                    {"$ " + formatNumber(totalMortgagePayment.toFixed(2))}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12 lg:col-6 mt-3 align-text">
              <label>Total Interest - </label>
            </div>
            <div className="col-12 md:col-12 lg:col-6 mt-3">
              <div>
                <div>
                  <label>{"$ " + formatNumber(totalInterest.toFixed(2))}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="grid ml-6 mt-5 mb-3 custom-background"
        style={{ width: "57rem" }}
      >
        {/* Flex Container for All Items */}
        <div
          className="flex align-items-center text-start ml-3"
          style={{ gap: "1rem", margin: "1rem" }}
        >
          <b>Optional</b>
          {/* Main Checkbox */}
          <div className="flex align-items-center">
            <Checkbox
              inputId="makeExtraPayments"
              className="custom-red-checkbox"
              onChange={(e) => {
                setChecked(e.checked);
                if (!e.checked) setExtra(false); // Reset "Uniform" checkbox when unchecked
                setPayment(0);
              }}
              checked={checked}
            />
            <label htmlFor="makeExtraPayments" className="ml-2">
              Make extra payments
            </label>
          </div>

          {/* Second Checkbox and Input Field */}
          {checked && (
            <>
              <div className="flex align-items-center">
                <Checkbox
                  inputId="uniformExtraPayments"
                  className="custom-red-checkbox"
                  onChange={(e) => {
                    setExtra(e.checked);
                    if (!e.checked) setPayment(0); // Reset input value
                  }}
                  checked={extra}
                />
                <label htmlFor="uniformExtraPayments" className="ml-2">
                  Uniform extra payments
                </label>
              </div>

              {/* Input Field */}
              {extra && (
                <div className="flex align-items-center">
                  <InputNumber
                    className="custom-input-number vw-inputnumber-with-border "
                    autoComplete="off"
                    value={extraPayment}
                    onValueChange={(e) => setPayment(e.value)}
                    prefix={"$ "}
                    placeholder="0"
                    maxFractionDigits={2}
                    style={{ width: "15rem" }}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className="grid mt-2 ml-6">
        <div className="col-2">
          <Button
            type="button"
            label="Calculate"
            className="p-button-raised p-button-warning p-button-lg-1"
            onClick={() => calculateAnnualSchedule(scheduleType)}
          />
        </div>
        <div className="col-2">
          <Button
            type="button"
            label="Save"
            className="p-button-raised p-button-warning p-button-lg-1"
            onClick={() => saveAnnualSchedule()}
          />
        </div>

        <div className="col-2 flex align-items-center">
          <label className="bold ml-2"> Amortization Schedule</label>
          &nbsp;
        </div>
        <div class="thick-dash flex align-items-center"></div>
        <div className="grid align-items-center tab-container col-4 ml-3">
          <Button
            label="Annual"
            className={`p-button-text activeButton ${
              scheduleType === "Annual" ? "bold" : ""
            }`}
            onClick={() => {
              setScheduleType("Annual");
              setChecked(false);
              setExtraPayment(0);

              if (newAnnualschedule?.length > 1) {
                let allZero = newAnnualschedule.every(
                  (item) => item.extraPayment === "0.00"
                );
                setChecked(!allZero);
                if (!allZero) {
                  // Check if extraPayment values are non-uniform
                  //isUniform = new Set(loan.loanSchedules.map(item => item.extraPayment)).size === 1;
                  const extraPayments = newAnnualschedule.map(
                    (item) => item.extraPayment
                  );
                  const isUniform = new Set(extraPayments).size === 1;
                  //  const isUniform =  extraPayments => extraPayments.every(v => v === extraPayments[0]);
                  setExtra(isUniform);
                  if (isUniform) {
                    setExtraPayment(extraPayments[0]);
                  }
                }
              } else {
                // setPayment(0);
                calculateAnnualSchedule("Annual");
              }
            }}
          />
          <label>|</label>
          <Button
            label="Monthly"
            className={`p-button-text activeButton ${
              scheduleType === "Monthly" ? "bold" : ""
            }`}
            onClick={() => {
              setScheduleType("Monthly");
              setChecked(false);
              setExtraPayment(0);

              if (newMonthlyschedule?.length > 0) {
                let allZero = newMonthlyschedule.every(
                  (item) => item.extraPayment === "0.00"
                );
                setChecked(!allZero);
                if (!allZero) {
                  // Check if extraPayment values are non-uniform
                  //isUniform = new Set(loan.loanSchedules.map(item => item.extraPayment)).size === 1;
                  const extraPayments = newMonthlyschedule.map(
                    (item) => item.extraPayment
                  );
                  const isUniform = new Set(
                    newMonthlyschedule.map((item) => item.extraPayment)
                  );
                  //  const isUniform =  extraPayments => extraPayments.every(v => v === extraPayments[0]);
                  setExtra(isUniform);
                  if (isUniform) {
                    setExtraPayment(extraPayments[0]);
                  }
                }
              } else {
                //setPayment(0);
                calculateAnnualSchedule("Monthly");
              }
            }}
          />
        </div>
      </div>

      <div className="mt-4">
        {scheduleType === "Monthly" ? (
          <DataTable
            value={mainDataMonth}
            stripedRows
            style={{ width: "100%" }}
          >
            <Column field="month" header="Month" style={{ width: "10%" }} />
            <Column header="Date" style={{ width: "15%" }} body={(rowData) => rowData.displayDate ? rowData.displayDate : rowData.date} />
            <Column
              field="interest"
              header="Interest"
              style={{ width: "15%" }}
              body={(rowData) => {
                const interest = formatNumber(rowData.interest);
                return interest ? "$ " + interest : ""; // Show $ only if interest exists
              }}
            />
            <Column
              field="principal"
              header="Principal"
              style={{ width: "15%" }}
              body={(rowData) => {
                const principal = formatNumber(rowData.principal);
                return principal ? "$ " + principal : ""; // Show $ only if interest exists
              }}
            />
            {checked && !extra && (
              <Column
                style={{ width: "15%" }}
                header="Extra Payment"
                body={extraPaymentTemplate}
              />
            )}
            {checked && extra && (
              <Column
                field="extraPayment"
                style={{ width: "15%" }}
                header="Extra Payment"
                body={(rowData) => {
                  const extra = formatNumber(rowData.extraPayment);
                  return extra ? "$ " + extra : ""; // Show $ only if interest exists
                }}
              />
            )}
            <Column
              field="balance"
              style={{ width: "15%" }}
              header="Ending Balance"
              body={(rowData) => {
                const balance = formatNumber(rowData.balance);
                return balance ? "$ " + balance : ""; // Show $ only if interest exists
              }}
            />
            <Column
              field="loanCategory"
              style={{ width: "15%" }}
              header="Loan"
            />
          </DataTable>
        ) : (
          <DataTable value={mainDataAnnual} stripedRows>
            <Column field="year" header="Year" style={{ width: "10%" }} />
            <Column header="Date" style={{ width: "15%" }} body={(rowData) => rowData.displayDate ? rowData.displayDate : (rowData.date ? new Date(rowData.date).getFullYear() : rowData.date)} />
            <Column
              field="interest"
              header="Total Interest"
              style={{ width: "15%" }}
              body={(rowData) => {
                const interest = formatNumber(rowData.interest);
                return interest ? "$ " + interest : ""; // Show $ only if interest exists
              }}
            />
            <Column
              field="principal"
              style={{ width: "15%" }}
              header="Total Principal"
              body={(rowData) => {
                const principal = formatNumber(rowData.principal);
                return principal ? "$ " + principal : ""; // Show $ only if interest exists
              }}
            />
            {checked && !extra && (
              <Column
                style={{ width: "15%" }}
                header="Extra Payment"
                body={extraPaymentTemplateAnnual}
              />
            )}
            {checked && extra && (
              <Column
                field="extraPayment"
                style={{ width: "15%" }}
                header="Extra Payment"
                body={(rowData) => {
                  const extra = formatNumber(rowData.extraPayment);
                  return extra ? "$ " + extra : ""; // Show $ only if interest exists
                }}
              />
            )}
            <Column
              field="balance"
              style={{ width: "15%" }}
              header="Ending Balance"
              body={(rowData) => {
                const balance = formatNumber(rowData.balance);
                return balance ? "$ " + balance : ""; // Show $ only if interest exists
              }}
            />
            <Column
              field="loanCategory"
              style={{ width: "15%" }}
              header="Loan"
            />
          </DataTable>
        )}
        <div className="flex justify-content-end p-4">
          {scheduleType === "Monthly" && newMonthlyschedule.length > 4 && (
            <Fragment>
              <Button
                label={!showMore ? "Show More" : "Show Less"}
                className="p-button-raised p-button-warning mr-2"
                onClick={handleShowMore}
              ></Button>
            </Fragment>
          )}
          {scheduleType === "Annual" && newAnnualschedule.length > 4 && (
            <Fragment>
              <Button
                label={!showMore ? "Show More" : "Show Less"}
                className="p-button-raised p-button-warning mr-2"
                onClick={handleShowMore}
              ></Button>
            </Fragment>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default MortgageSchedule;
